import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { RequestOptions } from '@app/types';
import { InvestmentPlanWithdrawTransferRequestDTO } from '@backend/dto';
import { Request } from '@backend/requests/request';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

class InvestmentPlanWithdrawTransferRequest extends Request<
  InvestmentPlanWithdrawTransferRequestDTO,
  void
> {
  constructor(options?: RequestOptions<InvestmentPlanWithdrawTransferRequestDTO>) {
    super({
      ...options,
      method: 'POST',
      path: `/broad${options?.version ?? '/v1'}/users/me/investment_plans/${
        options?.pathParams?.investmentPlanIdentifier
      }/transfers/withdraw`,
      headers: new HttpHeaders().set('Content-Type', 'application/json')
    });
  }

  public execute(): Observable<void> {
    return super.execute().pipe(map((response: HttpResponse<any>) => response.body));
  }
}

export function createInvestmentPlanWithdrawTransfer(
  options?: RequestOptions<InvestmentPlanWithdrawTransferRequestDTO>
): InvestmentPlanWithdrawTransferRequest {
  return new InvestmentPlanWithdrawTransferRequest(options);
}
